/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlertType } from '../../enums/alert-types';

@Component({
  selector: 'sysque-alert',
  templateUrl: './sysque-alert.component.html',
  styleUrls: ['./sysque-alert.component.scss'],
  standalone: false
})
export class SysqueAlertComponent {
  @Input() message: string;
  @Input() isDissmisible: boolean;
  @Input() alertType: string;
  @Input() isShow: boolean;
  @Input() alertName?: string;
  @Input() showAlertName: boolean;
  @Input() showOnMultiline?: boolean;
  @Output() closeButtonClicked = new EventEmitter();

  public imagePath: string;
  public classList: string;
  public altText: string;

  public onCloseButtonClicked(): void {
    this.closeButtonClicked.emit();
  }

  public onDismissClick(): void {
    this.hideAlert();
    this.closeButtonClicked.emit(true);
  }

  public hideAlert(): void {
    this.message = '';
    this.imagePath = '';
    this.classList = '';
    this.alertType = '';
    this.alertName = '';
    this.isShow = false;
    this.isDissmisible = false;
  }

  public getClassType(): string {
    const alertTypeToClassMap = {
      [AlertType.Success]: 'success msg-single',
      [AlertType.Error]: 'error msg-single',
      [AlertType.Warning]: 'warning msg-single',
      [AlertType.Info]: 'info msg-single',
      [AlertType.SuccessNextLine]: 'success msg-multi',
      [AlertType.ErrorNextLine]: 'error msg-multi',
      [AlertType.WarningNextLine]: 'warning msg-multi',
      [AlertType.InfoNextLine]: 'info msg-multi',
      [AlertType.WarningError]: 'warning msg-single',
    };

    const alertImageToClassMap = {
      [AlertType.Success]: 'assets/img/Success.png',
      [AlertType.Error]: 'assets/img/Error.png',
      [AlertType.Warning]: 'assets/img/warning.png',
      [AlertType.Info]: 'assets/img/Information.png',
      [AlertType.SuccessNextLine]: 'assets/img/Success.png',
      [AlertType.ErrorNextLine]: 'assets/img/Error.png',
      [AlertType.WarningNextLine]: 'assets/img/warning.png',
      [AlertType.InfoNextLine]: 'assets/img/Information.png',
      [AlertType.WarningError]: 'assets/img/warning.png',
    };

    const alertAltToClassMap = {
      [AlertType.Success]: 'success',
      [AlertType.Error]: 'error',
      [AlertType.Warning]: 'warning',
      [AlertType.Info]: 'info',
      [AlertType.SuccessNextLine]: 'success',
      [AlertType.ErrorNextLine]: 'error',
      [AlertType.WarningNextLine]: 'warning',
      [AlertType.InfoNextLine]: 'info',
      [AlertType.WarningError]: 'warning',
    };

    const alertTypeToModifierName = {
      [AlertType.Success]: 'Success',
      [AlertType.Error]: 'Failure',
      [AlertType.Warning]: 'Alert',
      [AlertType.Info]: 'Hint',
      [AlertType.SuccessNextLine]: 'Success',
      [AlertType.ErrorNextLine]: 'Failure',
      [AlertType.WarningNextLine]: 'Alert',
      [AlertType.InfoNextLine]: 'Hint',
      [AlertType.WarningError]: 'Error',
    };

    const classList = alertTypeToClassMap[this.alertType];
    const imageList = alertImageToClassMap[this.alertType];
    const altList = alertAltToClassMap[this.alertType];

    this.imagePath = imageList;
    this.altText = altList;
    this.classList = `sysque-alert-content ${classList}`;
    if (this.alertName === undefined) {
      this.alertName = alertTypeToModifierName[this.alertType];
    }

    return this.classList;
  }
}
